module.exports = __webpack_public_path__ + "static/img/course_arrange_widget_3.3eab59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/course_arrange_widget_3.png
// module id = 4aFt
// module chunks = 11